import PropTypes from 'prop-types';
import React from 'react';
import { getContactPairsByPosition } from '../../../utils/matchCardUtils';
import Img from '../../Img';
import ContactBlock from './ContactBlock';
import styles from './contactsInfoPopup.scss';

const ContactsInfoPopup = ({ onClose, position1MemberIds, position2MemberIds, participatingMembers = [] }) => {
    const members = participatingMembers || [];
    const pairs = getContactPairsByPosition(position1MemberIds, position2MemberIds, members);
    const contactEntries = pairs.flat();

    return (
        <div className={styles.contactsInfoPopup}>
            <div className={styles.overlay} onClick={onClose} aria-hidden="true" />
            <div
                className={styles.modal}
                role="dialog"
                aria-labelledby="contacts-modal-title"
            >
                <button
                    type="button"
                    className={styles.closeButton}
                    onClick={onClose}
                    aria-label="Close contacts"
                    data-testid="modal.contacts-info.close-btn"
                >
                    <Img
                        src="/img/v4/icon-24px-contact-close.svg"
                        className={styles.closeButtonIcon}
                        alt=""
                    />
                </button>
                <div className={styles.modalInner}>
                    <div className={styles.header}>
                        <div className={styles.headerRow}>
                            <span className={styles.headerSpacer} aria-hidden="true" />
                            <h2 id="contacts-modal-title" className={styles.title} data-testid="modal.contacts-info.title">Contacts</h2>
                            <button
                                type="button"
                                className={styles.closeButtonMobile}
                                onClick={onClose}
                                aria-label="Close contacts"
                                data-testid="modal.contacts-info.close-btn-mobile"
                            >
                                <Img
                                    src="/img/v4/icon-24px-contact-close.svg"
                                    className={styles.closeButtonMobileIcon}
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>
                    <div className={styles.content}>
                        {contactEntries.length === 0 && (
                            <p className={styles.emptyMessage} data-testid="modal.contacts-info.empty-message">No contact information available.</p>
                        )}
                        {contactEntries.length > 0 && (
                            <div className={styles.cardsRow}>
                                {pairs.map((pair) => (
                                    <div key={pair.map((e) => e.key).join('-')} className={styles.card}>
                                        {pair[0] && (
                                            <ContactBlock
                                                key={pair[0].key}
                                                name={pair[0].name}
                                                phone={pair[0].phone}
                                                email={pair[0].email}
                                                homeCourtName={pair[0].homeCourtName}
                                            />
                                        )}
                                        {pair.length > 1 && <div className={styles.separator} />}
                                        {pair[1] && (
                                            <ContactBlock
                                                key={pair[1].key}
                                                name={pair[1].name}
                                                phone={pair[1].phone}
                                                email={pair[1].email}
                                                homeCourtName={pair[1].homeCourtName}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

ContactsInfoPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    position1MemberIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    position2MemberIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    participatingMembers: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        memberId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        displayName: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
        homeCourtName: PropTypes.string,
    })),
};

ContactsInfoPopup.defaultProps = {
    position1MemberIds: null,
    position2MemberIds: null,
    participatingMembers: [],
};

export default ContactsInfoPopup;
